import React, { useRef, useLayoutEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import {
  Grid,
  GridNoRecords,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
// import { Traslates, SimpleLoading } from '../../pures'
// import './grid-list-request-detail.css'
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Label } from "@progress/kendo-react-labels";
import { useMediaQuery } from "@material-ui/core";
import "./signature-request-profile-list-signers.css";
import CheckBoxHLPure from "../checkBoxHL/checkBoxHL.pure";
import { TooltipHLPure } from '../'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  );
};

/* === Custom Component for th elements of the Grid === */
const signerCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#427FBA",
    fontFamily: "Quicksand, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
  };
  return <span id={props.id} style={cellHeaderStyles}>{props.title}</span>;
};

const signersCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#427FBA",
    fontFamily: "Quicksand, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
};
/* === Custom componente for td elements of the Grid === */
const signerCell = (props) => {
  return (
    <td className='signatureRequestProfileListSignersPure-cell-one'>
      <div className="">
        <p className='signatureRequestProfileListSignersPure-column1-title'>
          {props.dataItem.nameCompleted}
        </p>
        <p className='signatureRequestProfileListSignersPure-subtitle-column1'>
          {props.dataItem.email}
        </p>
      </div>
    </td>
  )
};

/* === Custom componente cells SignStatus for td elements of the Grid === */
const signerStatusSignCell = (props) => {
  let colorItem = "";
  if (props.dataItem.signStatusId) {
    if (props.dataItem.signStatusId === 2) {
      colorItem = "#005EA0";
    } else if (props.dataItem.signStatusId === 4) {
      colorItem = "#899232";
    } else if (props.dataItem.signStatusId === 3) {
      colorItem = "#F86A65";
    } else if (props.dataItem.signStatusId === 5) {
      colorItem = "#FF922C";
    } else {
      colorItem = "#4c4c4c";
    }
  }
  const cellItemStyles = {
    color: "#4c4c4c",
    fontSize: "14px",
    textTransform: "uppercase",
  };
  return (
    <td style={cellItemStyles} className="signatureRequestProfileListSignersPure-cell-three">
      <span style={{ color: `${colorItem}` }}>
        {props.dataItem[props.field]}
      </span>
    </td>
  );
};

const sendDocsCell = (props) => {
  return (
    <td className="signatureRequestProfileListSignersPure-cell-four">
      <CheckBoxHLPure
        disabled={true}
        valueCheckBox={props.dataItem.sendDocument}
        checkedState={props.dataItem.sendDocument}
      // onChangeHandler={(e) => changeSendDocument(dataItem, e.target.checked)}
      />
    </td>
  )
}

const sendDocsHeaderCell = (props) => {
  const cellHeaderStyles = {
    color: "#427FBA",
    fontFamily: "Quicksand, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
}


const ProofOfLifeCell = ({ dataItem }) => (
  <td className="signatureRequestProfileListSignersPure-cell-proofOfLife">
    <CheckBoxHLPure
      disabled={true}
      valueCheckBox={dataItem.proofOfLife}
      checkedState={dataItem.proofOfLife}
    // onChangeHandler={(e) => changeSendDocument(dataItem, e.target.checked)}
    />
  </td>
)

const GridHeaderWithOverflowTooltip = ({
  title,
  tooltipTitle,
  tooltipDescription,
  textColor = "#427FBA",
  fontSize = "14px",
  fontWeight = 600,
  wrapText = false,
  className,
  ...restProps
}) => {
  const textRef = useRef(null);
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const { t } = useTranslation();

  useLayoutEffect(() => {
    if (!textRef.current || !containerRef.current) return;

    const checkOverflow = () => {
      const el = textRef.current;
      setIsOverflowing(el.scrollWidth > el.offsetWidth);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(() => {
      checkOverflow();
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '-2px',
    width: '100%',
    gap: '6px'
  };

  const textStyle = {
    color: textColor,
    fontFamily: 'Quicksand, sans-serif',
    fontSize,
    fontWeight,
    whiteSpace: wrapText ? 'normal' : 'nowrap',
    overflow: wrapText ? 'visible' : 'hidden',
    textOverflow: wrapText ? 'unset' : 'ellipsis',
    wordBreak: wrapText ? 'break-word' : undefined,
    lineHeight: wrapText ? '1.3' : undefined,
    flex: 1
  };

  return (
    <div
      ref={containerRef}
      className={className}
      {...restProps}
      style={containerStyle}
    >
      <span ref={textRef} style={textStyle}>
        {title}
      </span>

      {isOverflowing && (
        <TooltipHLPure
          positionTooltip='top'
          titleTooltip={tooltipTitle ?? title}
          descriptionTooltip={tooltipDescription ?? title}
          informationIcon
        />
      )}
    </div>
  );
};

const NoPasswordCell = ({ dataItem }) => {
  const noPasswordValue = dataItem.noPasswordRequired ?? dataItem.isSignerNoPassword ?? false

  return (
    <td className='signatureRequestProfileListSignersPure-cell-noPassword'>
      <CheckBoxHLPure
        disabled={true}
        valueCheckBox={noPasswordValue}
        checkedState={noPasswordValue}
      />
    </td>
  )
}

const SignatureRequestProfileListSignersPure = (props) => {
  const { t } = useTranslation();
  const proofOfLifeActive = props.signers.some(signer => signer.proofOfLife)
  const showGovoAuth = useMediaQuery("(max-width:620px)");
  const showSignatures = useMediaQuery(proofOfLifeActive ? '(max-width:720px)' : '(max-width:620px)')
  const gridLabelNorecordsStyles = {
    color: "#828282",
    fontSize: "15px",
    fontWeight: 500,
  };
  let signatureTypeSelected =
    props.signatureTypeESignChecked === false &&
      props.signatureTypeAdvancedChecked === false &&
      props.signatureTypeAutographChecked === true
      ? true
      : false;

  // let processTypeSelected = props.processTypeRandomChecked === true || props.processTypeSequentialChecked === true || props.processTypeAprovationSequentialChecked === true || props.processTypeAprovationChecked === true ? true : false

  return (
    <div style={{ marginBottom: 20 }}>
      <Grid
        className="signatureRequestProfileListSignersPure-grid"
        data={props.signers.slice(props.skip, props.take + props.skip)}
        resizable
        reorderable
      >
        <Column
          field="nameCompleted"
          title={t("gridListSigners.titleName")}
          cell={signerCell}
          headerCell={signerCellHeader}
          headerClassName="signatureRequestProfileListSignersPure-header-one"
        />
        {/* {isAtgrafSignature && isShowIndex && (  */}
        {/* <Column
          field="typeName"
          title={t("signatureRequestProfileListSigners.rol")}
          width="auto"
          cell={signerStatusSignCell}
          headerCell={signerCellHeader}
        /> */}
        {!showSignatures && signatureTypeSelected === true ? (
          <Column
            width={90}
            title={t("newSignatureDetailView.signatoriesQuantity.title")}
            headerClassName="signatureRequestProfileListSignersPure-header-two"
            headerCell={(props) => (
              <GridHeaderWithOverflowTooltip
                {...props}
                title={props.title}
                tooltipTitle={t('newSignatureDetailView.signatoriesQuantity.title')}
                wrapText
              />
            )}
            cell={props.showOnlyNumber ? ({ dataItem }) => {
              return (
                <td
                  className="signatureRequestProfileListSignersPure-cell-two"
                >
                  {dataItem.numSign || 1}
                </td>
              )
            } : ({ dataItem }) => {
              return (
                <td
                  className="signatureRequestProfileListSignersPure-cell-two"
                >
                  {dataItem.numSign || 1}
                </td>
              );
            }}
          />
        ) : // )}
          null}
        {props.processTypeSequentialChecked === true ? (
          <Column
            field="id_order"
            title={t("newSignatureDetailView.signer.title")}
            cell={signerStatusSignCell}
            headerCell={(props) => (
              <GridHeaderWithOverflowTooltip
                {...props}
                title={props.title}
                tooltipTitle={t('signatureProfilesView.title.col.biometric validationType')}
              />
            )}
            headerClassName="signatureRequestProfileListSignersPure-header-three"
          />
        ) : null}
        {(!showGovoAuth && proofOfLifeActive) && (
          <Column
            title={t("signatureProfilesView.title.col.biometric validation")}
            cell={ProofOfLifeCell}
            headerCell={(props) => (
              <GridHeaderWithOverflowTooltip
                {...props}
                title={props.title}
                tooltipTitle={t('signatureProfilesView.title.col.biometric validationType')}
              />
            )}
            headerClassName="signatureRequestProfileListSignersPure-header-proofOfLife"
          />
        )}
        <Column
          field="id_order"
          title={t("signatureRequest.sendDocs.title")}
          cell={sendDocsCell}
          headerCell={(props) => (
            <GridHeaderWithOverflowTooltip
              {...props}
              title={props.title}
              tooltipTitle={t('signatureProfilesView.title.col.biometric validationType')}
            />
          )}
          headerClassName="signatureRequestProfileListSignersPure-header-four"
        />
        {props.signers.some(
          signer =>
            signer.noPasswordRequired === true ||
            signer.isSignerNoPassword === true
        ) && (
            <Column
              title={t('signatureRequest.noPassword.title')}
              cell={NoPasswordCell}
              headerCell={(props) => (
                <GridHeaderWithOverflowTooltip
                  {...props}
                  title={props.title}
                  tooltipTitle={t('signatureProfilesView.title.col.biometric validationType')}
                />
              )}
              headerClassName='signatureRequestProfileListSignersPure-header-noPassword'
            />
          )}
        <GridNoRecords>
          <p style={gridLabelNorecordsStyles}>
            {t("gridListSigners.noDataToShow")}
          </p>
        </GridNoRecords>
      </Grid>
    </div>
  );
};
export { SignatureRequestProfileListSignersPure as default };
